import {Stack,} from '@mantine/core';

import {useAccountApplications} from '../hooks/useAccountApplications.ts';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';


import {useAccountApplicationsSelection} from '../hooks/useAccountApplicationsSelection.ts';
import {
    AccountApplication,
    AccountApplicationStatus,
} from '../types';
import {useParams} from "react-router-dom";
import {useAccountApplicationsPaging} from '../hooks/useAccountApplicationsPaging.ts';
import {useAccountApplicationsSearch} from '../hooks/useAccountApplicationsSearch.ts';
import {DataTableColumn} from 'mantine-datatable';
import {useAccountApplicationsTableColumns} from '../hooks/useAccountApplicationsTableColumns.tsx';
import {rbacActions} from '../../../config/rbac/actions.ts';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import classes from './RecordsTable.module.css';


export const RecordsTable = (
    {
        records,
    }: {
        records: AccountApplication[],
    }
) => {


    const {id: accountId} = useParams()
    if (!accountId) {
        throw new Error('accountId is required parameter')
    }


    const {allowedActions} = useVerifiedPermissions()

    const {
        loading,
        visibleCount,
    } = useAccountApplications(accountId);

    const {
        columns,
    } = useAccountApplicationsTableColumns(accountId);

    const {
        page,
        limit,
        handleItemsPerPageChange,
        handlePageChange,
    } = useAccountApplicationsPaging(visibleCount);

    const {
        handleFilterByKeyword,
    } = useAccountApplicationsSearch();

    const {
        selection,
        handleClearSelection,
        handleRowSelection,
    } = useAccountApplicationsSelection();

    let selectedRecords = [] as AccountApplication[];
    if (allowedActions.includes(rbacActions.DeleteAccountApplication)) {
        selectedRecords = Object.keys(selection)
                                .filter(id => selection[id] === true)
                                .map(id => records.find(r => r.id === id))
                                .filter(Boolean) as AccountApplication[];
    }

    return (
        <Stack>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={(pageSize) => handleItemsPerPageChange(Number(pageSize))}
                handleFilterByKeyword={handleFilterByKeyword}
            />


            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                totalRecords={visibleCount}
                recordsPerPage={limit}
                page={page}
                onPageChange={handlePageChange}
                paginationText={({
                                     from,
                                     to,
                                     totalRecords
                                 }) => `Records ${from} - ${to} of ${totalRecords}`}
                paginationSize={'md'}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach(item => {
                        handleRowSelection((item as unknown as AccountApplication).id, true)
                    })
                }}
                rowClassName={(record) => {
                    if (record.accountApplicationStatus === AccountApplicationStatus.ACTIVE) {
                        return classes.active;
                    } else if (record.accountApplicationStatus === AccountApplicationStatus.INACTIVE) {
                        return classes.inactive;
                    }
                }}
                fetching={loading}
            />


        </Stack>
    );
};
